function Card(a) {
    this.id = a;
    this.number = "2"
    this.suit = "s";
    this.pile = "main";
    this.pilez = 0;
    this.showfront = true;
    this.cardUI = null;
}
function Pile() { }
Pile.prototype = new Array;

function Deck() {
    this.createDeck = function (deckName) {
        var cards = [];
        if (typeof deckName === 'undefined') deckName = "";
        for (var i = 1; i < 14; i++) {
            var card = new Card();
            card.id = i + "s" + deckName;
            card.ui = i + "s";
            card.number = i;
            card.suit = "s";
            cards.push(card);
        }
        for (var i = 1; i < 14; i++) {
            var card = new Card();
            card.id = i + "c" + deckName;
            card.ui = i + "c";
            card.number = i;
            card.suit = "c";
            cards.push(card);
        }
        for (var i = 1; i < 14; i++) {
            var card = new Card();
            card.id = i + "d" + deckName;
            card.ui = i + "d";
            card.number = i;
            card.suit = "d";
            cards.push(card);
        }
        for (var i = 1; i < 14; i++) {
            var card = new Card();
            card.id = i + "h" + deckName;;
            card.ui = i + "h";
            card.number = i;
            card.suit = "h";
            cards.push(card);
        }
        cards = this.shuffle(cards);
        return cards;
    }
    this.shuffle = function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }
}
import PlayerLocal from "./PlayerLocal.js";
export default class Speed {
    constructor() {
        //public
        this.state = "PreGame";
        this.winner = null;
        this.loser = null;
        this.cards = [];
        this.player1 = "Jimmy";
        this.player2 = "Hard";

        //todo:fix change to event instead of 2 function callbacks
        this.onMessage = function (message, value) { };
        this.onMessage2 = function (message, value) { };
        this.onMessage3 = function (message, value) { };
        this.onMessage4 = function (message, value) { };

        this.PlayerTop = new PlayerLocal(this, "Player2");
        this.PlayerBottom = new PlayerLocal(this, "Player1");
        this.MaxCardsInHand = 5;
        this.messageTip = "";
        this.eventTimer = null;
        this.elaspedTime = null;
        this.lastCardPlayedTime = 0;
        this.blockedCountTop = 0;
        this.blockedCountBottom = 0;
        this.maxStreakCountTop = 0;
        this.maxStreakCountBottom = 0;
        this.eventLog = [];
        this.debug = false;//todo: change to false when prod
        this.showSelection = true;
        this.isRanked = false;
        this.matchId = Math.floor((Math.random() * 100000000) + 1);
        this.gameMode = "All";
        this.allowDoubles = false;
        this.showReplayButton = false;
        this.winnerMsg = null;

        //simple console polyfill
        window.console = window.console || { log: function () { } };

        var deck = new Deck();
        this.cards = deck.createDeck();


    }

    message(message, value, location, player) {

        if (console.log !== undefined && this.debug === true) console.log(message + " : " + value + " : " + location + " : " + player + " : " + this.getElaspedTime());

        this.eventLog.push({ 'message': message, 'value': value, 'location': location, 'player': player, timestamp: this.getElaspedTime() });

        //todo:fix change to event instead of 2 function callbacks
        this.onMessage(message, value, location, player);
        this.onMessage2(message, value, location, player);
        this.onMessage3(message, value, location, player);
        this.onMessage4(message, value, location, player);

        if (this.PlayerTop) this.PlayerTop.gameEvent(message, value, location, player);
        if (this.PlayerBottom) this.PlayerBottom.gameEvent(message, value, location, player);


        if (!player) return;

        var otherPlayer = "PlayerTop";
        if (player === "PlayerTop") otherPlayer = "PlayerBottom";
        if (player === "PlayerBottom") otherPlayer = "PlayerTop";

        //check for complex events
        //blocked
        if (message === 'trydrop') {

            //get last card played
            var lastCardPlayed = null;
            for (var i in this.eventLog) {
                if (this.eventLog[i].message === 'cardMoved') lastCardPlayed = this.eventLog[i];
            }

            if (lastCardPlayed != null && lastCardPlayed.location == location) {
                //todo: fix for player local not player1
                this.message('blocked', value, location, player);
            }

            //disable hand if guessing too much
            this.disableHand(player);
        }
        //block combos
        if (message === 'blocked') {
            var blockedCount = 0;
            for (var i in this.eventLog) {
                if (this.eventLog[i].message === 'blocked' && this.eventLog[i].player === player) {
                    blockedCount++;
                }
            }
            //show message for block combos
            if (blockedCount === 1) this.message('combo', "Block", location, otherPlayer);
            if (blockedCount === 2) this.message('combo', "Double Block (2x)", location, otherPlayer);
            if (blockedCount === 3) this.message('combo', "Ninja Block (3x)", location, otherPlayer);
            if (blockedCount === 4) this.message('combo', "Crazy Ninja Block (4x)", location, otherPlayer);
            if (blockedCount === 5) this.message('combo', "Ultra Crazy Ninja Block (5x)", location, otherPlayer);
            if (blockedCount > 5) this.message('combo', "Ultra Crazy Ninja Block (" + blockedCount + "x)", location, otherPlayer);

            if (otherPlayer === "PlayerTop") {
                this.blockedCountTop = blockedCount;
            }
            if (otherPlayer === "PlayerBottom") {
                this.blockedCountBottom = blockedCount;
            }
        }
        //streaks combo

        if (message === 'cardMoved' && (location === 'hs1' || location === 'hs2')) {
            var streakCount = 0;
            for (var i = this.eventLog.length - 1; i >= 0; i--) {
                if (this.eventLog[i].message === 'cardMoved' && this.eventLog[i].player === player && (this.eventLog[i].location === 'hs1' || this.eventLog[i].location === 'hs2'))
                    streakCount++;
                if (this.eventLog[i].message === 'cardMoved' && this.eventLog[i].player !== player && (this.eventLog[i].location === 'hs1' || this.eventLog[i].location === 'hs2'))
                    break;
            }
            //show message for Streak combos
            if (streakCount === 3) this.message('combo', "Streak (3x)", location, player);
            if (streakCount === 4) this.message('combo', "Streak (4x)", location, player);
            if (streakCount === 5) this.message('combo', "Great Streak (5x)", location, player);
            if (streakCount === 6) this.message('combo', "Super Streak (6x)", location, player);
            if (streakCount === 7) this.message('combo', "Crazy Streak (7x)", location, player);
            if (streakCount === 8) this.message('combo', "On Fire Streak (8x)", location, player);
            if (streakCount === 9) this.message('combo', "Ninja Streak (9x)", location, player);
            if (streakCount > 9) this.message('combo', "Crazy Ninja Streak (" + streakCount + "x)", location, player);

            if (player === "PlayerTop") {
                this.streakCountTop = streakCount;
                this.streakCountBottom = 0;
                if (streakCount > this.maxStreakCountTop) {
                    this.maxStreakCountTop = streakCount;
                }
            }
            if (player === "PlayerBottom") {
                this.streakCountBottom = streakCount;
                this.streakCountTop = 0;
                if (streakCount > this.maxStreakCountBottom) {
                    this.maxStreakCountBottom = streakCount;
                }
            }

        }
        //todo:Straight combo
        //todo:flush combo
    }
    ready(player) {

        if (player == "Top"  &&  !this.PlayerTop.isReady) {
            this.PlayerTop.isReady = true;
            this.message("ready", null);
        }
        if (player == "Bottom" &&  !this.PlayerBottom.isReady) {
            this.PlayerBottom.isReady = true;
            this.message("ready", null);
        }
        
        if (this.PlayerTop.isReady && this.PlayerBottom.isReady) {
            this.start();
        }


    }
    //todo: pass in preset cards for diffrent modes like online mode does
    start(cards) {
        const gameMode = this.gameMode;
        if (!gameMode) {
            this.startClassic(cards);
        }
        if (gameMode === "Classic") {
            this.startClassic(cards);
        }
        if (gameMode === "BigHand") {
            this.startBigHandMode();
        }
        if (gameMode === "Doubles") {
            this.startDoublesMode();
        }
        if (gameMode === "EnduranceRun") {
            this.startEnduranRun();
        }       
        if (gameMode === "Online") {
            this.startClassic(cards);
        }
        if (gameMode === "Test") {
            this.startClassic(cards);
        }
        if (gameMode === "OnlineTest") {
            this.startClassic(cards);
        }

        this.state = "Playing";
        this.pull(true);
        this.startTime = Date.now();
        this.message("start", null);
        this.startEventTimer();
    }
    startClassic(cards) {
        this.state = "Playing";
        this.winner = null;
        this.loser = null;
        this.elaspedTime = null;
        this.lastCardPlayedTime = 0;
        this.blockedCountTop = 0;
        this.blockedCountBottom = 0;
        this.maxStreakCountTop = 0;
        this.maxStreakCountBottom = 0;
        this.streakCountTop = 0;
        this.streakCountBottom = 0;
        this.eventLog = [];
        this.MaxCardsInHand = 5;
        this.allowDoubles = false;
        this.enduranRun = false;

        if (!cards) {
            var deck = new Deck();
            this.cards = deck.createDeck();
            deck.shuffle(this.cards);
            for (var i = 0; i < this.cards.length; i++) {
                let card = this.cards[i];
                card.pile = "deck";
                card.pilez = i;
                card.selected = false;
                card.dragging = false;
            }
            for (var i = 0; i < 5; i++) {
                let card = this.cards[i];
                card.pile = "hand1";
                card.pilez = i;
            }
            for (var i = 5; i < 10; i++) {
                let card = this.cards[i];
                card.pile = "hand2";
                card.pilez = i;
            }
            for (var i = 10; i < 20; i++) {
                let card = this.cards[i];
                card.pile = "draw1";
                card.pilez = i;
            }
            for (var i = 20; i < 30; i++) {
                let card = this.cards[i];
                card.pile = "draw2";
                card.pilez = i;
            }

            // let card = this.cards[30];
            // card.pile = "hs1";
            // card = this.cards[31];
            // card.pile = "hs2";

            for (var i = 30; i < 41; i++) {
                let card = this.cards[i];
                card.pile = "pull1";
                card.pilez = i;
            }
            for (var i = 41; i < 52; i++) {
                let card = this.cards[i];
                card.pile = "pull2";
                card.pilez = i;
            }

            //this.pull(true);

            //serialize the cards and piles
            this.message("setUpGame", this.cards);
        }
        if (cards) {
            this.cards = cards;
            this.message("setUpGame", null);
        }

        this.state = "Playing";
        this.pull(true);
        this.startTime = Date.now();
        this.message("start", null);
        this.startEventTimer();

        this.message("cardsMoved", null); //update UI after setup
    }
    startBigHandMode() {
        this.startClassic();
        this.MaxCardsInHand = 15;
        this.FillHand1();
        this.FillHand2();
    }
    startDoublesMode() {
        this.startClassic();
        this.allowDoubles = true;
    }

    startEnduranRun() {
        var deck = new Deck();
        var cards = [];
        let card = null;

        cards = cards.concat(deck.createDeck("deck1"));
        cards = cards.concat(deck.createDeck("deck2"));
        cards = cards.concat(deck.createDeck("deck3"));
        deck.shuffle(cards);

        this.cards = cards;

        for (var i = 0; i < this.cards.length; i++) {
            let card = this.cards[i];
            card.pile = "deck";
            card.pilez = i;
            card.selected = false;
            card.dragging = false;
        }
        //5
        for (var i = 0; i < 5; i++) {
            let card = this.cards[i];
            card.pile = "hand1";
            card.pilez = i;
        }
        //5
        for (var i = 5; i < 10; i++) {
            let card = this.cards[i];
            card.pile = "hand2";
            card.pilez = i;
        }
        //40
        for (var i = 10; i < 50; i++) {
            let card = this.cards[i];
            card.pile = "draw1";
            card.pilez = i;
        }
        //40
        for (var i = 50; i < 90; i++) {
            let card = this.cards[i];
            card.pile = "draw2";
            card.pilez = i;
        }
        //2
        card = this.cards[91];
        card.pile = "hs1";
        card = this.cards[92];
        card.pile = "hs2";
        //32
        for (var i = 93; i < 125; i++) {
            let card = this.cards[i];
            card.pile = "pull1";
            card.pilez = i;
        }
        //32
        for (var i = 125; i < 156; i++) {
            let card = this.cards[i];
            card.pile = "pull2";
            card.pilez = i;
        }

        this.startClassic(cards);
    }
    reset() {
        this.state = "PreGame";
        this.winner = null;
        this.loser = null;
        this.elaspedTime = null;
        this.lastCardPlayedTime = 0;
        this.blockedCountTop = 0;
        this.blockedCountBottom = 0;
        this.streakCountTop = 0;
        this.streakCountBottom = 0;
        this.maxStreakCountTop = 0;
        this.maxStreakCountBottom = 0;
        this.eventLog = [];

        var deck = new Deck();
        deck.shuffle(this.cards);
        //this.cards = deck.createDeck();
        for (var i = 0; i < this.cards.length; i++) {
            let card = this.cards[i];
            card.pile = "hs1";
            card.pilez = i;
            card.selected = false;
        }
        for (var i = 25; i < 52; i++) {
            let card = this.cards[i];
            card.pile = "hs2";
            card.pilez = i;
            card.selected = false;
        }
        //serialize the cards and piles
        this.message("resetGame", this.cards, null, null);
    }

    //this.start = function () {
    //    this.state = "Playing";
    //    this.startTime = Date.now();
    //    this.message("start", null);
    //    this.startEventTimer();
    //}
    startEventTimer() {
        clearTimeout(this.eventTimer);
        this.eventTimer = setInterval(() => { this.onEventTimer(); }, 4000);
    }
    stopEventTimer() {
        clearTimeout(this.eventTimer);
    }
    getElaspedTime() {
        return (Date.now() - this.startTime) / 1000;
    }
    updateUI(player) {
        this.message("updateUI", null, null, player);
    }
    updateLayout(player) {
        this.message("updateLayout", null, null, player);
    }
    onEventTimer() {
        //check for hints if no card played for 5 seconds
        if (this.getElaspedTime() - this.lastCardPlayedTime > 5) {


            //check if can pull
            if (this.canPull()) {
                this.message("hint", "pull");
                return;
            }

            //check if player can fill hand
            if (this.canFillHand1()) {
                this.message("hint", "hand1");
                return;
            }

            //hint card to play
            var handCards = this.getPile("hand1");
            for (let i = 0; i < handCards.length; i++) {
                let card = handCards[i];
                if (this.canDrop(card, "hs1")) {
                    this.message("hint", handCards[i].id);
                    return;
                }
                if (this.canDrop(card, "hs2")) {
                    this.message("hint", handCards[i].id);
                    return;
                }
            }



            this.checkForGameOver();

        }
    }
    canDrop(card, pileName) {

        var pileCards = this.getPile(pileName);

        //could be a pile class that has the logic
        if (pileName === "hs1" || pileName === "hs2") {
            var topCard = pileCards[pileCards.length - 1];
            if (topCard === undefined) return true;
            if (topCard.number === card.number + 1) return true;
            if (topCard.number === card.number - 1) return true;
            if (topCard.number === 1 && card.number === 13) return true;
            if (topCard.number === 13 && card.number === 1) return true;
            if (this.allowDoubles === true && topCard.number === card.number) return true;

        }
        return false;
    }
    getPile(pileName) {
        var pileCards = new Array();
        for (let i = 0; i < this.cards.length; i++) {
            let card = this.cards[i];
            if (card.pile == pileName) {
                pileCards.push(card);
            }
        }
        pileCards = this.sortByKey(pileCards, "pilez");
        return pileCards;
    }
    getCard(cardId) {
        let cards = this.cards.filter(function (obj) {
            return obj.id == cardId;
        });
        let card = cards[0];
        return card;
    }
    addToPile(card, pileName, player) {

        if (card == undefined) return;

        //todo: getcard owner;
        //var player = this.getCardOwner(card);

        var pileCards = this.getPile(pileName);

        pileCards = this.sortByKey(pileCards, "pilez");
        for (var i = 0; i < pileCards.length; i++) {
            pileCards[i].pilez = i;
        }
        card.pile = pileName;
        card.pilez = pileCards.length;

        //todo: send who did the action, not owner of card or both?
        this.message("cardMoved", card.id, pileName, player);



        this.checkForGameOver();
        this.lastCardPlayedTime = this.getElaspedTime();

    }
    sortByKey(array, key) {
        return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    };

    canPlayCards() {
        //can play any cards?
        var handCards1 = this.getPile("hand1");
        for (var i = 0; i < handCards1.length; i++) {
            if (this.canDrop(handCards1[i], "hs1") === true) {
                return true;
            }
            if (this.canDrop(handCards1[i], "hs2") === true) {
                return true;
            }
        }
        //can play any cards?
        var handCards2 = this.getPile("hand2");
        for (var i = 0; i < handCards2.length; i++) {
            if (this.canDrop(handCards2[i], "hs1") === true) {
                return true;
            }
            if (this.canDrop(handCards2[i], "hs2") === true) {
                return true;
            }
        }
    }
    canFillHand1() {
        var drawCards = this.getPile("draw1");

        if (drawCards.length === 0) return false;

        var handCards = this.getPile("hand1");
        if (handCards.length === this.MaxCardsInHand) return false;

        return true;
    }
    FillHand1() {
        var handCards = this.getPile("hand1");
        var numberOfCardsToDraw = this.MaxCardsInHand - handCards.length;
        var drawCards = this.getPile("draw1");
        if (numberOfCardsToDraw === 0) return false;
        for (var i = 0; i < numberOfCardsToDraw; i++) {
            var card = drawCards.pop();
            this.addToPile(card, "hand1");
        }
        this.message("fillHand", "hand1");
        return true;
    }
    canFillHand2() {
        var drawCards = this.getPile("draw2");
        if (drawCards.length === 0) return false;

        var handCards = this.getPile("hand2");
        if (handCards.length === this.MaxCardsInHand) return false;

        return true;
    }
    FillHand2() {
        var handCards = this.getPile("hand2");
        var numberOfCardsToDraw = this.MaxCardsInHand - handCards.length;
        var drawCards = this.getPile("draw2");
        if (numberOfCardsToDraw === 0) return false;
        for (var i = 0; i < numberOfCardsToDraw; i++) {
            var card = drawCards.pop();
            this.addToPile(card, "hand2");
        }
        this.message("fillHand", "hand2");
        return true;
    }
    disableHand(player) {

        var isHandDisabled = this.isHandDisabled(player);
        if (isHandDisabled) {
            this.message("disablehand", player);
            //todo: send message to player
        }
    }
    isHandDisabled(player) {
        var seconds = 2;
        var maxTryDrop = 4;
        var eventLog = this.eventLog;
        var elaspedTime = this.getElaspedTime();

        //get last try drop time
        var lastDrop = null;
        for (var i in eventLog) {
            if (eventLog[i].message === 'drop' && eventLog[i].player === player) lastDrop = eventLog[i];
        }
        var lastDropTime = 0;
        if (lastDrop) lastDropTime = lastDrop.timestamp;
        var lastDropCard = 0;
        if (lastDrop) lastDropCard = lastDrop.value;

        //get last card played
        var trydropCount = 0;
        var lastCard = 0;
        for (var i in eventLog) {
            var log = eventLog[i];
            if (log.timestamp < lastDropTime) continue;
            if (log.value === lastDropCard) continue;
            if (log.timestamp < (elaspedTime - seconds)) continue;
            if (log.message !== 'trydrop') continue;
            if (log.value === lastCard) continue;
            if (log.player !== player) continue;

            trydropCount += 1;
            lastCard = log.value; //dont count 2x trydrop in a row cause by  suto drop or playing the same card
        }

        if (trydropCount >= maxTryDrop)
            return true;

        return false;
    }
    canPull() {

        if (this.state !== "Playing") return false;

        //can pull?
        var pullCards1 = this.getPile("pull1");
        var pullCards2 = this.getPile("pull2");
        if (pullCards1.length == 0 && pullCards2.length == 0) {
            return false;
        }


        //if longer than 10 seconds you can pull another card from pile
        //get last card played
        var lastCardPlayed_timestamp = null;
        for (var i in this.eventLog) {
            if (this.eventLog[i].message === 'cardMoved') {
                var timestamp = this.eventLog[i].timestamp;
                lastCardPlayed_timestamp = Math.max(timestamp, lastCardPlayed_timestamp);
            }
        }
        var elaspedTime = this.getElaspedTime();
        if (lastCardPlayed_timestamp && elaspedTime - lastCardPlayed_timestamp > 10) {
            return true;
        }


        //can pull?
        var handCards1 = this.getPile("hand1");
        var drawCards1 = this.getPile("draw1");


        //hand is not full and there are cards to pull
        if (handCards1.length < 5 && drawCards1.length > 0) {
            this.message("message", "Can't pull, cause handCards1 is not full");
            return false;
        }
        //can play any cards?
        for (var i = 0; i < handCards1.length; i++) {
            if (this.canDrop(handCards1[i], "hs1") === true) {
                this.message("message", "Can't pull, cause handCards1 has a card to play on HS1");
                return false;
            }
            if (this.canDrop(handCards1[i], "hs2") === true) {
                this.message("message", "Can't pull, cause handCards1 has a card to play on HS2");
                return false;
            }
        }


        var handCards2 = this.getPile("hand2");
        var drawCards2 = this.getPile("draw2");
        //hand is not full and there are cards to pull
        if (handCards2.length < 5 && drawCards2.length > 0) {
            this.message("message", "Can't pull, cause handCards2 is not full");
            return false;
        }
        //can play any cards?
        for (var i = 0; i < handCards2.length; i++) {
            if (this.canDrop(handCards2[i], "hs1") === true) {
                this.message("message", "Can't pull, cause handCards1 has a card to play on HS1");
                return false;
            }
            if (this.canDrop(handCards2[i], "hs2") === true) {
                this.message("message", "Can't pull, cause handCards1 has a card to play on HS2");
                return false;
            }
        }
        return true;
    }
    pull(force) {

        if (this.canPull() === false && !force) return false;

        //pull card
        var cardPile = this.getPile("pull1");
        var card = cardPile.pop();
        this.addToPile(card, "hs1");

        var cardPile = this.getPile("pull2");
        var card = cardPile.pop();
        this.addToPile(card, "hs2");


        this.message("pull", null);
        this.message("cardsMoved", null);
        return true;
    }
    checkForGameOver() {
        if (this.state === "PreGame") return;
        if (this.state === "GameOver") return;


        //check for winners (top)
        var cardPileHand = this.getPile("hand1");
        var cardPileDraw = this.getPile("draw1");
        if (cardPileHand.length == 0 && cardPileDraw.length == 0) {
            this.gameOver(this.PlayerBottom, this.PlayerTop);
        }

        //check for winners (bottom)
        var cardPileHand = this.getPile("hand2");
        var cardPileDraw = this.getPile("draw2");
        if (cardPileHand.length == 0 && cardPileDraw.length == 0) {
            this.gameOver(this.PlayerTop, this.PlayerBottom);
        }

        //check for tie game
        if (this.checkForTie()) {
            this.gameOverTie();
        }

        if (this.winner == null) return;


    };
    gameOver(winner, loser) {

        this.winner = winner;
        this.loser = loser;

        this.state = "GameOver";
        this.winnerMsg = winner.name + " Wins!";

        var elaspedTime = this.getElaspedTime();
        this.elaspedTime = elaspedTime;

        //get pull count
        this.pullCount = 0;
        for (var i in this.eventLog) {
            if (this.eventLog[i].message === 'pull') this.pullCount++;
        }
        //get last card played
        this.lastCardPlayed = null;
        for (var i in this.eventLog) {
            if (this.eventLog[i].message === 'cardMoved') this.lastCardPlayed = this.eventLog[i];
        }


        this.message("gameover", this.winner.name);

        // this.pause();
        this.stopEventTimer();



    }
    gameOverTie() {
        this.winner = "tie";

        this.state = "GameOver";
        this.winnerMsg = "Tie!";

        var elaspedTime = this.getElaspedTime();
        this.elaspedTime = elaspedTime;

        //get pull count
        this.pullCount = 0;
        for (var i in this.eventLog) {
            if (this.eventLog[i].message === 'pull') this.pullCount++;
        }
        //get last card played
        this.lastCardPlayed = null;
        for (var i in this.eventLog) {
            if (this.eventLog[i].message === 'cardMoved') this.lastCardPlayed = this.eventLog[i];
        }

        this.message("gameover");

        this.stopEventTimer();
    }
    checkForPlayer1Win() {
        var cardPile = this.getPile("hand1");
        if (cardPile.length > 0) return false;

        var cardPile = this.getPile("draw1");
        if (cardPile.length > 0) return false;

        return true;
    }
    tcheckForPlayer2Win() {
        var cardPile = this.getPile("hand2");
        if (cardPile.length > 0) return false;

        var cardPile = this.getPile("draw2");
        if (cardPile.length > 0) return false;

        return true;
    }
    checkForTie() {

        //can't pull(play) and no cards left to pull?
        var pullCards1 = this.getPile("pull1");
        var pullCards2 = this.getPile("pull2");
        var pullCardLeft = (pullCards1.length > 0 && pullCards2.length > 0);

        if (pullCardLeft) return false;
        if (this.canPlayCards()) return false;
        if (this.canFillHand1()) return false;
        if (this.canFillHand2()) return false;

        //todo: get last card played
        //todo: need to be over 5 seconds ago, but what would trigger it in 5 seconds to check for tie

        return true;
    }

    pause() {
        this.message("pause");
        this.stopEventTimer();
    }
    resume() {

        this.message("resume");
        this.startEventTimer();
    }
    destroy() {
        //send destroy msg, player objects will also receive this
        this.message("destroy");

        this.state = "GameOver";
        this.onMessage = function () { };
        this.onMessage2 = function () { };
        this.onMessage3 = function () { };
        this.onMessage4 = function () { };

        if (this.PlayerTop) this.PlayerTop.destroy();
        if (this.PlayerBottom) this.PlayerBottom.destroy();

        this.stopEventTimer();
    }

    moveCardToPile(card, pileName, speed, player, callback) {
        this.message("moveCardToPile", card.id + ":" + pileName + ":" + speed, pileName, player);

        //todo: run call back after time
        //todo: have computer use this and not own timer

        //selectedCard.dragging = true;
        //this.message("moveCardToPile", selectedCard.id + ":hs2:" + computerMoveCardSpeed);
        //setTimeout(function () {
        //    t.tryPlayCard(selectedCard, "hs2");
        //    selectedCard.dragging = false;
        //}, computerMoveCardSpeed);
    }
    stopMoveCardToPile(card, pileName, speed, player, callback) {
        this.message("stopMoveCardToPile", card.id + ":" + pileName + ":" + speed, pileName, player);
    }
    tryPlayCard(card, pileName, player) {
        //var player = this.getCardOwner(card);//todo: might be part of the card properties later
        if (!player) player = this.getCardOwner(card);//todo: might be part of the card properties later
        if (this.canDrop(card, pileName)) {
            this.message("drop", card.id, pileName, player);
            this.addToPile(card, pileName, player);
            return true;
        }

        this.message("trydrop", card.id, pileName, player);

        return false;
    }
    getCardOwner(card) {
        if (card == undefined) return;

        if (card.pile == 'draw1') return "PlayerBottom";
        if (card.pile == 'hand1') return "PlayerBottom";
        if (card.pile == 'draw2') return "PlayerTop";
        if (card.pile == 'hand2') return "PlayerTop";
        return null;
    }


}
